// Modules
import React from 'react'
import { Input } from '@dasa-health/alma-react'
import { Control, Controller, FieldValues } from 'react-hook-form'
// Application
import { onlyNumbersOnChange, getFieldError } from 'redesign/utils/form'

export const InputStringNumber = ({ control, name, label }: { control: unknown; name: string; label: string }) => (
    <Controller
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        control={control as Control<FieldValues, any> | undefined}
        name={name}
        render={({ field, fieldState, formState }) => (
            <Input
                autoComplete="off"
                inputMode="numeric"
                {...getFieldError(fieldState, formState)}
                {...field}
                label={label}
                onChange={e => field.onChange(onlyNumbersOnChange(e.target.value, field.value))}
                readOnly={formState.isSubmitting}
                type="tel"
                width="100%"
            />
        )}
    />
)
